import { EmployeeDto, Roles } from '../pages/user/userTypes';

/**
 * Role hierarchy: ADMIN implies MAINTAINER implies USER.
 * The Keycloak realm only assigns USER and ADMIN, so MAINTAINER-restricted
 * features are reached by ADMINs via this hierarchy.
 */
const roleRank: { [key in Roles]: number } = {
  [Roles.USER]: 1,
  [Roles.MAINTAINER]: 2,
  [Roles.ADMIN]: 3,
};

export const hasRole = (role: Roles) => (employee: EmployeeDto): boolean => employee.roles.indexOf(role) >= 0;
export const isAdmin = hasRole(Roles.ADMIN);

export function hasMinRole(role: Roles, employee: EmployeeDto): boolean {
  const required = roleRank[role];
  return employee.roles.some(r => roleRank[r] >= required);
}
